import axios from 'axios';
import getApiBaseUrl from '../GetServer';

export const ChangeStatusRol = async (IDRol: number) => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/change-status-role`;

    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('Token no disponible');
    }

const response = await axios.post(
      endpoint,
      { 
        IDRol
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (response.data.status !== 200) {
      throw new Error(response.data.message);
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
};